import WbHttpClient from './../../services/wbhttpclient';

export default class OrgResultsServices extends WbHttpClient{

  public getUsersList(params: any = {}) {
    let url = `goal/getTeamUsersList?term=${params.term}`
    return this.post(url, params);
  }

  public getOrgResults(params: any = {}) {
    let url = `goal/orgResults?timestamp=${params.timestamp}&userId=${params.forData.userId}&teamId=${params.forData.teamId}`
    //return this.post(url, params);
    return this.get(url, {});
  }

  public getPopupData(params: any = {}){
    let url = `goal/orgResTeam?type=${params.type}&userId=${params.userId}&teamId=${params.teamId}&offset=${params.offset}&timestamp=${params.timestamp}`
    return this.get(url, {});
  }

  public nudgeAll(params: any = {}){
    let url = `goal/sendTeamPingNotification`;
    return this.post(url, params);
  }

  public resultAnalyticsEvents(params: any = {}){
    let url = `goal/resultAnalyticsEvents`;
    return this.post(url, params);
  }
}